<template>
  <div class="offerte" v-loading="loading">

    <transition name="fade">
      <ricerca v-show="showSearchPanel"
               @closeRicerca="closeSearch"
               @cerca="cerca"
               @loadingOff="setLoading(false)">
      </ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-2 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('offerte.cerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
    </div>

    <el-table :data="offerte" @sort-change="sortChange" class="custom-table" :row-class-name="getRowClass">

      <el-table-column header-align="center" align="center"
                       width="70">
        <template slot="header" slot-scope="scope">
          <el-popover :key="scope.length"
            placement="top"
            width="300"
            trigger="click"
            popper-class="custom-popover"
          >
            <div slot="reference">
              <icon name="riv-help" class="pointer" scale="1"></icon>
            </div>
            <div class="legenda">
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <!-- NUOVE OFFERTE NON HANNO ICONA -->
                </div>
                <div class="col-20 custom-label">
                  {{ $t('offerte.N').toUpperCase() }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-saveDoc" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('offerte.S').toUpperCase() }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-sendDoc" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('offerte.I').toUpperCase() }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: #cbb385" name="riv-save" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('offerte.S_Riaperta').toUpperCase() }}
                </div>
              </div>
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="stato-wrapper">
            <icon style ="color: black" v-if="(scope.row.codAvanz === 'I')" name="riv-sendDoc" scale="1.2"></icon>
            <icon style ="color: black" v-if="(scope.row.codAvanz === 'S' && scope.row.variante === '0')" name="riv-saveDoc" scale="1.2"></icon>
            <icon style ="color: #cbb385" v-if="(scope.row.codAvanz === 'S' && scope.row.variante !== '0')" name="riv-save" scale="1.2"></icon>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        prop="numRif" header-align="center" align="center" class-name="sfondino"
        :label="$t('offerte.offerta')" sortable="custom"
        width="150">

        <template slot-scope="scope">
          <div class="name-wrapper pointer" @click="selectOfferta(scope.row)">
            {{ scope.row.numRif }}
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center"
        :label="$t('offerte.dataOfferta')" sortable="custom" prop="datOfferta"
        min-width="100">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ moment(scope.row.datOfferta, 'DDMMYYYY').format('DD/MM/YYYY') }}
          </div>
        </template>

      </el-table-column>
      <el-table-column
        prop="descStab"
        :label="$t('offerte.stabilimento')"
        min-width="170">
      </el-table-column>
      <el-table-column
        prop="societaDes"
        :label="$t('offerte.societa')"
        min-width="170">
      </el-table-column>
      <el-table-column
        width="50">

        <template slot-scope="scope">
          <div class="name-wrapper pointer pdf" v-if="(scope.row.hasOwnProperty('keyDoc') && scope.row.keyDoc !== '')">
            <icon name="riv-pdf_RGB" scale="1.4" class="pointer" @click.native.stop="downloadDoc(scope.row)" />
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="50">

        <template slot-scope="scope">
          <div class="name-wrapper pointer actions" @click="selectOfferta(scope.row)">
            <icon name="riv-arrow" scale="1.1"></icon>
          </div>
        </template>

      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination"
                   background
                   layout="prev, pager, next"
                   :total="nrItems"
                   :page-size="pag_for"
                   @current-change="changePage">
    </el-pagination>

  </div>
</template>

<script>
  import Ricerca from './Ricerca.vue'
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'Offerte',
    components: {Ricerca},
    i18n: {
      messages: {
        it_IT: {
          offerte: {
            stabilimento: 'Stabilimento',
            stato: 'Stato',
            offerta: 'Rich. di Offerta',
            dataOfferta: 'Data',
            societa: 'Società',
            legendaTitolo: 'Legenda Stati Offerta',
            I: 'Offerta Inviata',
            S: 'Offerta Salvata',
            N: 'Nuova Offerta',
            S_Riaperta: 'Negoziazione',
            cerca: 'Cerca',
            dettaglioOfferta: 'Dettaglio Offerta'
          }
        },
        fr_FR: {
          offerte: {
            stabilimento: 'Usine',
            stato: 'État',
            offerta: 'Offre',
            dataOfferta: 'Date de l\'Offre',
            societa: 'Société',
            legendaTitolo: 'Légende des Etats d\'Offrandes',
            I: 'Offre Envoyée',
            S: 'Offre Enregistrée',
            N: 'Nouvelle Offre',
            S_Riaperta: 'Transaction',
            cerca: 'Recherche',
            dettaglioOfferta: 'Détail de l\'Offre'
          }
        },
        es_ES: {
          offerte: {
            stabilimento: 'Fábrica',
            stato: 'Estado',
            offerta: 'Oferta',
            dataOfferta: 'Fecha de Oferta',
            societa: 'Empresa',
            legendaTitolo: 'Leyenda de los Estados de Ofrendas',
            I: 'Oferta Enviada',
            S: 'Oferta Guardada',
            N: 'Nueva Oferta',
            S_Riaperta: 'Relación Comercial',
            cerca: 'Búsqueda',
            dettaglioOfferta: 'Detalle Oferta'
          }
        },
        de_DE: {
          offerte: {
            stabilimento: 'Werk',
            stato: 'Zustand',
            offerta: 'Angebot',
            dataOfferta: 'Angebotsdatum',
            societa: 'Firma',
            legendaTitolo: 'Legende der Angebotsstaaten',
            I: 'Angebot Versandt',
            S: 'Angebot Gespeichert',
            N: 'Neues Angebot',
            S_Riaperta: 'Handel',
            cerca: 'Suche',
            dettaglioOfferta: 'Angebotsdetails'
          }
        },
        en_GB: {
          offerte: {
            stabilimento: 'Establishment',
            stato: 'State',
            offerta: 'Offer',
            dataOfferta: 'Offer date',
            societa: 'Company',
            legendaTitolo: 'Legend of the Offer States',
            I: 'Sent Offer',
            S: 'Saved Offer',
            N: 'New Offer',
            S_Riaperta: 'Dealing',
            cerca: 'Search',
            dettaglioOfferta: 'Offer Detail'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loading: false,
        codLang: sessionStorage.getItem('codLang'),
        showSearchPanel: false,
        form: {
          country: '',
          codForn: '',
          codSoc: '',
          codMag: '',
          numRif: '',
          codAvanz: ''
        },
        offerte: [],
        pag_for: 12,
        currentPage: 1,
        nrPages: 0,
        nrItems: 0,
        ordine: '2D'
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'offerte', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
      bus.$on('UFFACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'offerte', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          if (sessionStorage.hasOwnProperty('RdO_form')) {
            this.$set(this, 'form', JSON.parse(sessionStorage.getItem('RdO_form')))
            this.ricerca()
          }
        })
      },
      resetDati: function () {
        this.$set(this, 'loading', false)
        this.$set(this, 'showSearchPanel', false)
        let form = {
          country: '',
          codForn: '',
          codSoc: '',
          codMag: '',
          numRif: '',
          codAvanz: ''
        }
        this.$set(this, 'form', form)
        this.$set(this, 'offerte', [])
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'loading', false)
      },
      downloadDoc: function (offerta) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringAcquisti + 'print/documento' +
                '?keyDoc=' + offerta.keyDoc +
                '&idCli=' + offerta.idCli + '&idApp=' + offerta.idApp +
                '&token=' + response.body.wsToken
              )
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      setLoading: function (val) {
        this.$set(this, 'loading', val)
      },
      openSearch: function () {
        this.$set(this, 'showSearchPanel', true)
        this.$emit('hideScroll')
        this.$emit('closeMessages')
      },
      closeSearch: function () {
        this.$emit('showScroll')
        this.$set(this, 'showSearchPanel', false)
      },
      changePage: function (page) {
        this.$set(this, 'currentPage', page)
        this.ricerca()
      },
      selectOfferta: function (offerta) {
        sessionStorage.setItem('RdO_offerta', JSON.stringify(offerta))
        this.$router.push({name: 'RdODettaglioOfferta'})
      },
      cerca: function (form) {
        let formRicerca = JSON.parse(form)
        this.$set(this, 'form', formRicerca)
        this.$set(this, 'currentPage', 1)
        if (!this._inactive) {
          this.ricerca()
        }
      },
      sortChange: function ({column, prop, order}) {
        if (prop === 'numRif') {
          if (order === 'ascending') {
            this.ordine = '1A'
          } else if (order === 'descending') {
            this.ordine = '1D'
          }
        } else if (prop === 'datOfferta') {
          if (order === 'ascending') {
            this.ordine = '2A'
          } else if (order === 'descending') {
            this.ordine = '2D'
          }
        }
        this.ricerca(true)
      },
      ricerca: function (flagIfChangeSort) {
        this.$set(this, 'loading', true)
        if (flagIfChangeSort) {
          this.$set(this, 'currentPage', 1)
        }

        // Flag per sapere se ho cambiato Stato e/o codForn
        let flagChange = false

        // Se il codForn salvato nel sessionStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (sessionStorage.getItem('UFFACQ_fornitore') !== this.form.codForn) {
          sessionStorage.setItem('UFFACQ_fornitore', this.form.codForn)
          flagChange = true
        }

        // Se lo Stato salvato nel localStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (localStorage.getItem('UFFACQ_country') !== this.form.country) {
          localStorage.setItem('UFFACQ_country', parseInt(this.form.country))
          flagChange = true
        }
        bus.$emit('Header_ChangeAdmin', this.form.country, 'UFFACQ')

        // Sono cambiati Stato e/o codForn
        if (flagChange) {
          bus.$emit('UFFACQ_ChangeCountryFromApp')
        }

        this.$http.get('richiestediofferta/offerte', {
          params: {
            country: this.form.country,
            codLang: this.codLang,
            codForn: this.form.codForn,
            codSoc: this.form.numRif ? this.form.codSoc : '',
            codMag: this.form.numRif ? this.form.codMag : '',
            numRif: this.form.numRif,
            codAvanz: this.form.numRif ? this.form.codAvanz : '',
            tipOrd: this.ordine,
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: ((this.currentPage - 1) * this.pag_for) + 1,
            pag_for: this.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              sessionStorage.setItem('RdO_form', JSON.stringify(this.form))
              this.$set(this, 'offerte', response.body.data)

              if (this.currentPage === 1) {
                let size = parseInt(response.body.attrib.size)
                this.$set(this, 'nrItems', size)

                let resto = size % this.pag_for
                let aggiunta = (resto > 0) ? 1 : 0
                let nrPages = Math.floor(size / this.pag_for) + aggiunta
                this.$set(this, 'nrPages', nrPages)
              }

              this.closeSearch()

              if (this.form.numRif) {
                this.$set(this.form, 'codSoc', '')
                this.$set(this.form, 'codMag', '')
                this.$set(this.form, 'codAvanz', '')
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          })
      },
      getRowClass: function ({row, rowIndex}) {
        if (row.variante !== '0' && row.codAvanz === 'S') {
          return 'offerta-riaperta'
        }
        return ''
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .offerte {
    .header-tab {
      height: 65px;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table {
      height: 460px;
      margin-top: 5px;
      .el-table__header {
        thead {
          th {
            .cell {
              .el-popover__reference {
                padding-top: 0;
                line-height: 16px;
              }
            }
          }
        }
      }
      .el-table__body {
        tr {
          .cell {
            .actions {
              text-align: right;
              padding-right: 7px;
            }
            .pdf {
              text-align: right;
            }
          }
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiOfferta/Offerte.vue